export default function formatPhone(value) {

  if (value === '' || value === null || !value) {
    return '';
  }
  const digitCount = (value.match(/\d/g) || []).length;

  const mask =
    digitCount > 10
      ? ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
      : ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

  let maskedValue = '';
  let valueIndex = 0;

  maskedValue = mask.reduce((acc, char) => {
    if (char instanceof RegExp) {
      while (value[valueIndex] && !char.test(value[valueIndex])) {
        valueIndex += 1;
      }
      if (value[valueIndex]) {
        acc += value[valueIndex];
        valueIndex += 1;
      }
    } else {
      acc += char;
    }
    return acc;
  }, '');

  return maskedValue;
}
